export const NAME = 'settings';

export const CHANGE_PASSWORD_REQUEST = `${NAME}/CHANGE_PASSWORD_REQUEST`;
export const CHANGE_PASSWORD_FAILURE = `${NAME}/CHANGE_PASSWORD_FAILURE`;
export const CHANGE_PASSWORD_SUCCESS = `${NAME}/CHANGE_PASSWORD_SUCCESS`;
